import esLocale from 'date-fns/locale/es';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Grid,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import Message from '../../../../../../common/Message';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';

import Loader from '../../../tracking/trackingLoading.gif';

import {
  makeSelfServiceByMotive,
  openModalConfirmationTicket,
  validateProductByMotive,
} from '../../../../../../../redux/actions/TicketActions';

import {
  genericSelfServiceBody,
  validationBodyGenerator,
} from '../../../../../../../helpers/tickets/SelfService';
import { changeDispatchDateErrorMsg } from '../../../../../../../constants/Messages';

import { dispatchDateStyles } from './styles';
import { reportIssueFormStyles } from '../styles';
import { formatDateWithoutTime } from '../../../../../../../helpers/DateFormatter';

const ButtonTitle = ({ selfServiceStatus }) => {
  return (
    <>
      {selfServiceStatus === 'loading' ? (
        <CircularProgress size={24} />
      ) : (
        'Enviar'
      )}
    </>
  );
};

ButtonTitle.propTypes = {
  selfServiceStatus: PropTypes.string,
};

const localeMap = {
  es: esLocale,
};

const ChangeDispatchDate = ({ ...props }) => {
  const {
    mobile,
    motiveId,
    product,
    type,
    onData,
    profile,
    selfServiceStatus,
  } = props;
  const [checked, setChecked] = useState(false);
  const [locale, setLocale] = useState('es');
  const [selectedDate, setSelectedDate] = useState(new Date());

  const { validationStatus, validation, confirmationTicket } = useSelector(
    (innerState) => innerState.ticketReducer,
  );
  const dispatchDateClasses = dispatchDateStyles({ mobile });
  const reportIssueFormClasses = reportIssueFormStyles({ mobile });

  const dispatch = useDispatch();

  const selfServiceBodyGenerator = () => ({
    ...genericSelfServiceBody({ product, profile, type, validation }),
    newDate: selectedDate,
  });

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const clickConfirmButton = () => {
    dispatch(
      openModalConfirmationTicket({
        motiveId,
        selectedDate,
      }),
    );
  };

  const handleSelfService = () => {
    dispatch(makeSelfServiceByMotive(motiveId, selfServiceBodyGenerator()));
    onData({
      motiveId,
      message: formatDateWithoutTime(new Date(selectedDate.toString())),
    });
  };

  useEffect(() => {
    setLocale(locale);

    if (mobile) {
      const body = validationBodyGenerator(props);
      dispatch(validateProductByMotive(motiveId, body));
    }
  }, []);

  useEffect(() => {
    if (confirmationTicket) {
      handleSelfService();
    }
  }, [confirmationTicket]);

  return (
    <>
      {validationStatus === 'validating' && (
        <Box display="flex" justifyContent="center" margin="0 auto">
          <img src={Loader} className={reportIssueFormClasses.loader} />
        </Box>
      )}
      {validationStatus === 'error' && (
        <Box className={reportIssueFormClasses.container}>
          <Message
            severity="info"
            message={changeDispatchDateErrorMsg(validation.id)}
            fullRounded
          />
        </Box>
      )}
      {validationStatus === 'succeded' && (
        <Box
          display="flex"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className={reportIssueFormClasses.container}
        >
          <Box>
            <Typography variant="h5">
              Selecciona una nueva fecha de entrega:
            </Typography>
          </Box>
          <MuiPickersUtilsProvider
            utils={DateFnsUtils}
            locale={localeMap[locale]}
          >
            <Grid
              container
              justify="space-around"
              className={dispatchDateClasses.datepicker}
            >
              <KeyboardDatePicker
                emptyLabel
                disableToolbar
                variant="static"
                format="MM/dd/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Fecha de despacho"
                value={selectedDate}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  'aria-label': 'Cambiar fecha',
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <Box>
            <Typography variant="h5">
              *El despacho se realizará a cualquier hora del dí­a
            </Typography>
          </Box>
          <AuthorizeCheckbox
            disabled={!selectedDate}
            idComplement={'DispatchDate'}
            onCheck={(e) => setChecked(e)}
          />
          <Button
            className={reportIssueFormClasses.button}
            variant="contained"
            color="primary"
            disabled={
              !selectedDate || !checked || selfServiceStatus === 'loading'
            }
            onClick={clickConfirmButton}
            data-cy="buttonSendChangeDispatchDate"
          >
            <ButtonTitle selfServiceStatus={selfServiceStatus} />
          </Button>
        </Box>
      )}
    </>
  );
};

ChangeDispatchDate.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  onData: PropTypes.func,
  profile: PropTypes.object,
  selfServiceStatus: PropTypes.string,
};

export default ChangeDispatchDate;
